module.exports = __webpack_public_path__ + "img/b1.6289c312.jpg";